import type { MouseEvent } from 'react'

// Smoothly scrolls to the qualification form, leaving room for the fixed navbar.
export function scrollToForm(event?: MouseEvent<HTMLElement>) {
  const form = document.getElementById('calificar')
  if (!form) return
  event?.preventDefault()
  const navOffset = 72
  const top = form.getBoundingClientRect().top + window.scrollY - navOffset
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
  if (window.history.replaceState) {
    window.history.replaceState(null, '', '#calificar')
  }
}
